export const CommunicationChannelTypes = {
  EmailAddress: 'EmailAddress'
};

export const CommunicationChannelStatus = {
  Active: 'Active',
  Inactive: 'Inactive'
};